import React from 'react';
import { useNavigate } from 'react-router-dom';
import { FileX, Home, ArrowLeft } from 'lucide-react';

const NotFoundPage = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-gray-50 dark:bg-gray-900 flex items-center justify-center p-4">
      <div className="max-w-md w-full text-center">
        <div className="w-24 h-24 bg-gray-100 dark:bg-gray-800 rounded-full flex items-center justify-center mx-auto mb-6">
          <FileX className="w-12 h-12 text-gray-400" />
        </div>

        <h1 className="text-6xl font-bold text-gray-900 dark:text-white mb-4">
          404
        </h1>

        <h2 className="text-xl font-semibold text-gray-900 dark:text-white mb-2">
          Page not found
        </h2>

        <p className="text-gray-500 dark:text-gray-400 mb-8">
          The page you're looking for doesn't exist or has been removed.
        </p>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
          <button
            onClick={() => navigate(-1)}
            className="btn btn-secondary flex items-center gap-2 w-full sm:w-auto"
          >
            <ArrowLeft className="w-5 h-5" />
            Go back
          </button>
          <button
            onClick={() => navigate('/')}
            className="btn btn-primary flex items-center gap-2 w-full sm:w-auto"
          >
            <Home className="w-5 h-5" />
            Homepage
          </button>
        </div>

        {/* Credits */}
        <div className="mt-12 text-gray-400 dark:text-gray-500 text-sm">
          <span className="font-semibold">DocumentVault</span>
          <span className="mx-2">·</span>
          <span>Made by Varga Levente</span>
        </div>
      </div>
    </div>
  );
};

export default NotFoundPage;
